<template>
    <div class="row">
      <div class="col-12">
        <h1>User profile page</h1>
      </div>
    </div>

</template>

<script>

export default {
  data () {
    return {}
  },
  computed: {},
  methods: {},
  watch: {}
}
</script>



// WEBPACK FOOTER //
// src/views/UserProfile.vue